<template>
    <div>
        <el-dialog
            :title="`模块：${log.modulesType}，项目：${log.project}`"
            :visible="visible"
            @close="cancel" width="90%">
            <div class="divBox">
                上下文条数：
                <el-input v-model="keywordNum" style="width: 10%;margin-right: 20px;" type="number"></el-input>
                <el-button type="primary" @click="getDetail" :loading="isLoading">搜索</el-button>
            </div>
            <div v-if="detail" class="divBox">
                <div v-html="detail"></div>
            </div>
            <div v-else class="divBox">
                暂无数据
            </div>
            <div style="margin-top: 20px;text-align: center;">
                <el-button @click="cancel">关闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default{
        props: {
            visible: {
                type: Boolean
            },
            // 选中的日志
            log: {
                type: Object
            }
        },
        data: vm=>({
            keywordNum: 5, //默认搜上下文5条
            detail: '',
            isLoading: false
        }),
        created(){
            this.getDetail()
        },
        methods: {
            getDetail(){
                this.isLoading = true
                this.$axios.post(this.baseUrl3 + 'log/es/search/detail', {
                        moduleType: this.log.modulesType,
                        fullDateTime: this.log.fulldatetime,
                        keywordNum: this.keywordNum
                    })
                .then(({data: {code, data, msg}})=>{
                    this.isLoading = false
                    if(code == 20000){
                        this.detail = data ? data.replace(/\n/g, "<br/>") : ''
                    }else{
                        this.$message.error(msg)
                    }

                })
                .catch(err => {
                    this.isLoading = false
                    console.log(err)
                })
            },
            cancel(){
                this.$emit('closeLog')
            }
        }
    }
</script>
<style scoped>
    .divBox{
        margin: 10px 0px;
    }
</style>
